import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_THREAD_OPENED_TYPES = ['new', 'existing'] as const;

export type WorkspaceAgentThreadOpenedType = (typeof WORKSPACE_AGENT_THREAD_OPENED_TYPES)[number];

export const WORKSPACE_AGENT_THREAD_CREATED_LOCATIONS = [
  'header',
  'toolbar',
  'tasks_list',
  'fab',
  'uploads_offer',
  'imports_offer',
  'board_menu',
  'onboarding',
  'announcement',
] as const;

export type WorkspaceAgentThreadCreatedLocation = (typeof WORKSPACE_AGENT_THREAD_CREATED_LOCATIONS)[number];

export const WORKSPACE_AGENT_THREAD_REOPENED_STATUSES = ['active', 'archived'] as const;

export type WorkspaceAgentThreadReopenedStatus = (typeof WORKSPACE_AGENT_THREAD_REOPENED_STATUSES)[number];

export const WORKSPACE_AGENT_THREAD_REOPENED_FROM = ['automation_run'] as const;

export type WorkspaceAgentThreadReopenedFrom = (typeof WORKSPACE_AGENT_THREAD_REOPENED_FROM)[number];

const META: Meta = {
  description:
    'The user opens a workspace agent thread — either a new thread on first send or an existing thread from My Tasks or URL restore',
  name: 'agent_thread_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Whether this is a newly created thread or an existing thread being reopened',
      name: 'type',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_THREAD_OPENED_TYPES],
    },
    {
      description: 'Where the new thread was started from (required when type is new)',
      name: 'location',
      required: false,
      type: 'enum',
      values: [...WORKSPACE_AGENT_THREAD_CREATED_LOCATIONS],
    },
    {
      description: 'The archived state of the existing thread (required when type is existing)',
      name: 'status',
      required: false,
      type: 'enum',
      values: [...WORKSPACE_AGENT_THREAD_REOPENED_STATUSES],
    },
    {
      description: 'True when the opened thread is the first-run onboarding walkthrough reopened from My Tasks',
      name: 'is_first_run_walkthrough',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'The id of the workspace agent session. Required when type is new, and when an existing thread is reopened, except the first-run walkthrough',
      name: 'session_id',
      required: false,
      type: 'string',
    },
    {
      description: 'When an existing thread was reopened from an automation run (only when type is existing)',
      name: 'reopened_from',
      required: false,
      type: 'enum',
      values: [...WORKSPACE_AGENT_THREAD_REOPENED_FROM],
    },
  ],
};

export default META;
